/**
 * Copyright © Ircam Amplify 2024-2026
 */

import { useEffect, useState } from 'react'

interface StatusCompProps {
  status?: string
  forWebhooks?: boolean
}

function StatusComp({ status = '', forWebhooks }: StatusCompProps) {
  const [statusName, setStatusName] = useState('')

  useEffect(() => {
    switch (status) {
      case 'success':
        setStatusName(forWebhooks ? 'Success' : 'Complete')
        break
      case 'error':
        setStatusName(forWebhooks ? 'Error' : 'Failed')
        break
      case 'running':
        setStatusName('Running')
        break
      case 'created':
        setStatusName('Queued')
        break
      default:
        setStatusName('')
        break
    }
  }, [status])

  return (
    <div className={`status ${status}`}>
      <div className="circle" />
      {statusName}
    </div>
  )
}

export default StatusComp
